// all the ADs except the one handled by Parent product
export const selectAttributeDefinitionsForVariants = (state) => (
  state.attributeDefinitions.items.filter((ad) => ad.uid != 'b2f419dd-da7e-4158-8d0a-d91f6b4635b5')
);
export const selectAttributeDefinitions = (state) => state.attributeDefinitions.items;
export const selectAttributesShowFilter = (state) => state.attributeDefinitions.showFilter;
export const selectAttributesFilterValue = (state) => state.attributeDefinitions.filterValue;
